<script setup lang="ts">
    import type { Benefit } from '~/app/auth/enums/TenantSubscriptionPlan';

    const props = defineProps<{
        benefit: Benefit;
        label: string;
        icon?: string;
        title?: string;
        description?: string;
    }>();

    const { $theme } = useNuxtApp();
    const { canAccessBenefit } = useUpsellAccess();
    const { t } = useTranslation();
    const blocked = computed(() => !canAccessBenefit(props.benefit));

    const handleClick = () => {
        if (blocked.value) {
            // The modal tracks the upsell exposure on open (type: 'context_menu', label: item name).
            useEvent('upsell:modal:open', {
                benefit: props.benefit,
                title: props.title,
                description: props.description,
                type: 'context_menu',
                label: t(props.label),
            });
        }
    };
</script>

<template>
    <!-- If accessible, render normal slot content -->
    <slot v-if="!blocked" />

    <!-- If blocked, render upsell item -->
    <a
        v-else
        href="#"
        :class="$theme('contextmenu.link')"
        class="relative"
        @click.prevent="handleClick"
    >
        <i
            v-if="icon"
            :class="[icon, $theme('contextmenu.icon')]"
        />
        <span class="flex-1">{{ $t(label) }}</span>
        <CommonUpsellBadge
            variant="lightning"
            class="ml-auto"
        />
    </a>
</template>
